import { useState, useMemo, useCallback } from "react";
import { PinkBaseButton, SECONDARY, PRIMARY } from "components/buttons/PinkBaseButton";
import { ReactComponent as PlusIcon } from "../icons/plusIcon.svg";
import { nFormatter } from "../../utils/parseNumber";
import { clsx } from "clsx";
import { ITag } from "services/types";
import "./SelectTags.scss";

interface IProps {
  tags: ITag[];
  expanded?: boolean;
  showAmount?: boolean;
  setTags: (tags: string[]) => void;
  mainSelectedTags: string[];
  invertColor?: boolean;
}

const PAGE_SIZE = 30;

const SelectTags = (props: IProps) => {
  const { tags, expanded, showAmount, setTags, mainSelectedTags: selectedTags, invertColor } = props;
  const [page, setPage] = useState(2);
  const mainSelectedTags = useMemo(() => selectedTags || [], [selectedTags]);

  const amountOfShrinkedTags = PAGE_SIZE * page;

  const paginatedTags = useMemo(() => {
    if (!tags) {
      return [];
    }

    const newTags = tags.slice(0, PAGE_SIZE * page);

    return newTags.filter((tag: ITag) => !mainSelectedTags.includes(tag.name));
  }, [tags, mainSelectedTags, page]);

  const handleTagClick = useCallback((tag: ITag) => {
    let tagText = tag.name;
    if (showAmount && tag.name) {
      tagText = tag.name;
    }

    if (tagText !== null) {
      setTags([...mainSelectedTags, tagText]);
    } else {
      // eslint-disable-next-line
      console.warn("Oops, an empty tag clicked.");
    }
  }, [showAmount, mainSelectedTags, setTags]);

  const onMoreClick = () => {
    setPage(page + 1);
  };

  const handleTagDelete = useCallback((tag: string) => {
    if (mainSelectedTags.includes(tag)) {
      setTags(
        mainSelectedTags.filter((t: string) => t !== tag)
      );
    }
  }, [mainSelectedTags, setTags]);

  return (
    <div id="tagsblock" className={clsx("SelectTags", !!expanded && "SelectTags_isExpanded")}>
      {mainSelectedTags && mainSelectedTags?.map((el: string, index: number) => (
        <div key={el} className={clsx(
          "SelectTags-Button",
          invertColor && "SelectTags-Button_isInverted",
          "SelectTags-Button_isSelected"
        )}>
          <PinkBaseButton
            variant={PRIMARY}
            onClick={() => handleTagDelete(el)}
          >
            {el}
          </PinkBaseButton>
        </div>
      ))}
      {(tags && tags.length > 0) ? paginatedTags?.map((tag: ITag, index: number) =>
        <div key={tag.name} className={clsx(
          "SelectTags-Button",
          invertColor && "SelectTags-Button_isInverted",
          (index > amountOfShrinkedTags) && "SelectTags-Button_isHide",
        )}>
          <PinkBaseButton
            variant={SECONDARY}
            onClick={() => handleTagClick(tag)}
          >
            {showAmount ? (
              <p>{tag.name}{showAmount && <span>{nFormatter(tag.count)}</span> }</p>
            ) : tag.name}
          </PinkBaseButton>
        </div>
      ) : <p style={{ fontSize: "14px" }}>The tag does not exists.</p>}
      {tags.length > 3 && !expanded ?
        <div className="SelectTags-ButtonMore">
          <PinkBaseButton onClick={onMoreClick} type="button">
            <PlusIcon />
          </PinkBaseButton>
        </div> : null}
    </div>
  );
};

export default SelectTags;
